<template>
    <div class="product">
      <div class="product-item-1" id="product-0">
        <el-carousel :interval="4000" type="" height="100%">
          <el-carousel-item v-for="item in swiperList" :key="item.path">
            <img :src="item.path" class="product-item-1-swiper-img" @click="openTab('pages/home/dashboard/index')" />
          </el-carousel-item>
         </el-carousel>
      </div>
      <product-component id="product-1" :backImg="Item4" path="packages/goods/detail/index" param="alias=36bsyu9y9uzqwjt&shopAutoEnter=1" />
      <product-component id="product-2" :backImg="Item5" path="packages/goods/detail/index" param="alias=3ns1r3qfqm0g8mm&shopAutoEnter=1" />
      <product-component id="product-3" :backImg="Item6" path="packages/goods/detail/index" param="alias=2ojahh0lg9ak833&shopAutoEnter=1" />
      <product-component id="product-4" :backImg="Item7" path="packages/goods/detail/index" param="alias=2orxxoq5pqmjsgn&shopAutoEnter=1" />
      <product-component id="product-5" :backImg="Item8" path="packages/goods/detail/index" param="alias=3ewz7hx58qjjs82&shopAutoEnter=1" />
      <product-component id="product-6" :backImg="Item9" path="packages/goods/detail/index" param="alias=2fls4511f8rugy8&shopAutoEnter=1" />
      <product-component id="product-7" :backImg="Item10" path="packages/goods/detail/index" param="alias=2g0jwb2wiq5s8pm&shopAutoEnter=1" />
      <product-component id="product-8" :backImg="Item11" path="packages/goods/detail/index" param="alias=3epmcli8tndnsuo&shopAutoEnter=1" />
      <product-component id="product-9" :backImg="Item12" path="packages/goods/detail/index" param="alias=2xkhvn5hnr9488f&shopAutoEnter=1" />
      <product-component id="product-10" :backImg="Item13" path="packages/goods/detail/index" param="alias=2xi05nukku6o8&shopAutoEnter=1" />
      <mini-menu title="产品" />
    </div>
  </template>
   
  <script>
  import MiniMenu from "../components/MiniMenu.vue";
  import ProductComponent from "./Product/component.vue";
  import { jump } from "@/util";
  export default {
    name: "Product",
    components: {
      MiniMenu,
      ProductComponent
    },
    data() {
      return {
        swiperList: [
          {path: "https://minipika-stg-public.oss-cn-guangzhou.aliyuncs.com/home/product/item1.png"},
          {path: "https://minipika-stg-public.oss-cn-guangzhou.aliyuncs.com/home/product/item2.jpg"},
          {path: "https://minipika-stg-public.oss-cn-guangzhou.aliyuncs.com/home/product/item1.jpg"},
        ],
        Item4: "https://minipika-stg-public.oss-cn-guangzhou.aliyuncs.com/home/product/item4.png",
        Item5: "https://minipika-stg-public.oss-cn-guangzhou.aliyuncs.com/home/product/item5.png",
        Item6: "https://minipika-stg-public.oss-cn-guangzhou.aliyuncs.com/home/product/item6.png",
        Item7: "https://minipika-stg-public.oss-cn-guangzhou.aliyuncs.com/home/product/item7.png",
        Item8: "https://minipika-stg-public.oss-cn-guangzhou.aliyuncs.com/home/product/item8.png",
        Item9: "https://minipika-stg-public.oss-cn-guangzhou.aliyuncs.com/home/product/item9.jpg",
        Item10: "https://minipika-stg-public.oss-cn-guangzhou.aliyuncs.com/home/product/item10.jpg",
        Item11: "https://minipika-stg-public.oss-cn-guangzhou.aliyuncs.com/home/product/item11.jpg",
        Item12: "https://minipika-stg-public.oss-cn-guangzhou.aliyuncs.com/home/product/item12.jpg",
        Item13: "https://minipika-stg-public.oss-cn-guangzhou.aliyuncs.com/home/product/item13.jpg",
      }
    },
    methods: {
      openTab(path) {
        jump('wx7067da25149f33f7', path)
      }
    },
    mounted() {
    }
  };
  </script>
   
  <style lang="scss" scoped>
  .product {
    width: 100%;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    position: relative;
    &-item-1 {
      width: 100%;
      aspect-ratio: 1920/1289;
      .el-carousel {
        width: 100%;
        height: 100%;
      }
      .el-carousel__item {
        width: 100%;
        height: 100%;
      }
      &-swiper-img {
        width: 100%;
        height: 100%;
        background-position: 50% 50%;
        background-repeat: no-repeat;
        background-size: contain;
      }
    }
  }
  </style>